<ng-template [ngIf]="!location && optionsCombo && !autocomplete">
	<p><label for="{{randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory" class="mandatory">*</span>
		<span class="glyphicon glyphicon-info-sign" *ngIf="info && info.length > 0" [tooltip]="info"></span>
		<select autocomplete="on" [(ngModel)]="internalObject.id" class="form-control" id="{{randomId}}"[ngClass]="getClass() + ' ' + getHighlight()" (change)="onChange()" [ngStyle]="{'color': internalObject && internalObject.color ? internalObject.color : 'inherit'}"
			[disabled]="submitPending || disabledSelect" [attr.aria-required]="mandatory">
			<option *ngIf="!noDefaultOption" style="color: #555 !important;" [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id | orderBy : labelOption+':'+orderListType : noOrder"
				[selected]="option.id === internalObject.id"
				[value]="option?option[valueOption]:null" [disabled]="disabledCheck && option[disabledCheckProperty]" [ngStyle]="{'color': option.color ? option.color : 'inherit'}">
				<ng-template [ngIf]="isImporto">
					<ng-container *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
						{{labelOpt | euro}}
					</ng-container>
				</ng-template>
				<ng-template [ngIf]="!isImporto">
					<ng-container *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
						{{labelOpt}}
					</ng-container>
				</ng-template>
			</option>
		</select>
	</p>
</ng-template>

<ng-template [ngIf]="!location && optionsCombo && autocomplete">
	<p class="select-autocomplete" [ngClass]="getClass()"><label for="{{'autocomplete_' + randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory"
			class="mandatory">*</span>
		<ng-template #rt let-r="result" let-t="term">
			<ngb-highlight [result]="getLabelOption( r, (labelOption ? labelOption : 'label'))" [term]="t"></ngb-highlight>
		</ng-template>
		<input id="{{'autocomplete_'+randomId}}" type="text" class="form-control" placeholder="Seleziona" [attr.aria-multiline]="null"
			[(ngModel)]="internalObject" [ngbTypeahead]="search" [resultTemplate]="rt" role="combobox"
			(click)="click$.next($event.target.value)" (selectItem)="onSelectItem($event)" [inputFormatter]="formatter"
			[disabled]="submitPending" [attr.aria-required]="mandatory" (keyup)="onChangeInput($event)" (blur)="changeValue()" #instance="ngbTypeahead" />
	</p>
</ng-template>

<ng-template [ngIf]="location == 'mesi' && optionsCombo">
	<p><label for="{{'mesi_'+randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory" class="mandatory">*</span>
		<select autocomplete="on" id="{{'mesi_'+randomId}}" [(ngModel)]="internalObject.id" class="form-control" (change)="onChange()" [disabled]="submitPending" [attr.aria-required]="mandatory">
			<option [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id"
				[value]="option?option[valueOption]:null" [disabled]="disabledCheck && option[disabledCheckProperty]"
				[selected]="option.id === internalObject.id">
				<div *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
					{{labelOpt}}</div>
			</option>
		</select>
	</p>
</ng-template>

<ng-template [ngIf]="location == 'accessori' && optionsCombo">
	<p>	<label for="{{'accessori_'+randomId}}">
			<small class="sr-only">{{labelInput}}</small>
			<span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span>
		</label>
		<span *ngIf="mandatory" class="mandatory accessori">*</span>
		<select autocomplete="on" id="{{'accessori_'+randomId}}" [(ngModel)]="internalObject.id" class="form-control"
			(change)="onChange()" [disabled]="submitPending" [attr.aria-required]="mandatory">
			<option [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id | orderBy : labelOption+':'+orderListType"
				[value]="option?option[valueOption]:null" [disabled]="disabledCheck && option[disabledCheckProperty]">
				<div *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
					{{labelOpt}}</div>
			</option>
		</select>
	</p>
</ng-template>

<ng-template [ngIf]="(location == 'conteggi' || location == 'sezioneEconomica') && optionsCombo">
	<p class="col-sm-9 bloccodati">
		<label for="{{'conteggi_'+randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory" class="mandatory">*</span>
	</p>
	<p class="col-sm-3">
		<select autocomplete="on" id="{{'conteggi_'+randomId}}" [(ngModel)]="internalObject.id" class="alignright form-control" (change)="onChange()"
			[disabled]="submitPending" [attr.aria-required]="mandatory">
			<option [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id"
				[value]="option?.id" [disabled]="disabledCheck && option[disabledCheckProperty]">
				<div *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
					{{labelOpt}}</div>
			</option>
		</select>
	</p>
</ng-template>

<ng-template [ngIf]="location == 'parcelle' && optionsCombo">
	<p class="col-sm-offset-2 col-sm-2 alignright">
		<label for="{{'parcelle_'+randomId}}" >{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory" class="mandatory">*</span>
	</p>
	<p class="col-sm-5 alignright">
		<select autocomplete="on" id="{{'parcelle_'+randomId}}" [(ngModel)]="internalObject.id" class="alignright form-control" (change)="onChange()"
			[disabled]="submitPending" [attr.aria-required]="mandatory">
			<option [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id"
				[value]="option?.id" [disabled]="disabledCheck && option[disabledCheckProperty]">
				<div *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
					{{labelOpt}}</div>
			</option>
		</select>
	</p>
</ng-template>

<ng-template [ngIf]="location == 'gruppiVisibilita' && optionsCombo">
	<p><label for="{{'gruppiVisibilita_'+randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory" class="mandatory">*</span>
		<select autocomplete="on" id="{{'gruppiVisibilita_'+randomId}}" [(ngModel)]="internalObject.id" class="form-control" (change)="onChange()" [disabled]="submitPending" [attr.aria-required]="mandatory">
			<option [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id"
				[value]="option.gruppoVisibilita?.id">
				<div *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
					{{labelOpt}}</div>
			</option>
		</select>
	</p>
</ng-template>

<ng-template [ngIf]="location === 'plus' && optionsCombo && autocomplete">
	<p class="select-autocomplete" [ngClass]="getClass()"><label for="{{'plus_'+randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory"
			class="mandatory">*</span>
		<ng-template #rt let-r="result" let-t="term">
			<ngb-highlight [result]="r.label" [term]="t"></ngb-highlight>
		</ng-template>
		<span style="white-space: nowrap;">
			<input id="{{'plus_'+randomId}}" type="text" class="form-control" placeholder="{{'Seleziona ' + labelInput}}" style="display: inline-block; width: 90%; margin-bottom: 10px;"
				[(ngModel)]="internalObject" [ngbTypeahead]="search" [resultTemplate]="rt"
				(click)="click$.next($event.target.value)" (selectItem)="onSelectItem($event)"
				[inputFormatter]="formatter" [disabled]="submitPending" [attr.aria-required]="mandatory" (keyup)="onChangeInput($event); txt = $event.target.value"
				#instance="ngbTypeahead" />
			<button (click)="addRecord(txt)" [disabled]="!txt" [tooltip]="'Aggiungi ' + labelInput" [attr.aria-label]="'Aggiungi ' + labelInput"><span *ngIf="txt" class="glyphicon glyphicon-plus plus-active"></span>
			<span *ngIf="!txt" class="glyphicon glyphicon-plus plus-grey"></span></button>
		</span>
	</p>
</ng-template>

<ng-template [ngIf]="location === 'soggettoPagatoreIncassi' && optionsCombo">
	<p><label for="{{randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory" class="mandatory">*</span>
		<select autocomplete="on" [(ngModel)]="internalObject.id" class="form-control" id="{{randomId}}"[ngClass]="getClass()" (change)="onChange()"
			[disabled]="submitPending" [attr.aria-required]="mandatory">
			<option [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id | orderBy : labelOption+':'+orderListType : noOrder"
				[value]="option?option[valueOption]:null" [disabled]="disabledCheck && option[disabledCheckProperty]">
				<ng-container *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
					{{labelOpt + (
						option.responsabileCivile ? ' (RESP. CIVILE)' :
						option.infortunato ? ' (INFORTUNATO)' :
						''
					)}}
				</ng-container>
			</option>
		</select>
	</p>
</ng-template>

<ng-template [ngIf]="location === 'comune' || location === 'provincia'">
	<p><label for="{{randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory" class="mandatory">*</span>
		<span class="glyphicon glyphicon-info-sign" *ngIf="info && info.length > 0" [tooltip]="info"></span>
		<select autocomplete="on" [(ngModel)]="internalObject.id" class="form-control" id="{{randomId}}"[ngClass]="getClass() + ' ' + getHighlight()" (change)="onChange()"
			[disabled]="submitPending" [attr.aria-required]="mandatory">
			<option [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id | orderBy : labelOption+':'+orderListType : noOrder"
				[value]="option?option[valueOption]:null" [disabled]="disabledCheck && option[disabledCheckProperty]">
				<ng-template [ngIf]="!isImporto">
					<ng-container *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
						{{labelOpt}} {{option.statoValidita && option.statoValidita === 'I' ? '(SOPPRESSO)' : ''}}
					</ng-container>
				</ng-template>
			</option>
		</select>
	</p>
</ng-template>

<ng-template [ngIf]="location === 'nazione'">
	<p><label for="{{randomId}}">{{labelInput}} <span class="sr-only" *ngIf="highlight">{{highlightLabel}}</span></label><span *ngIf="mandatory" class="mandatory">*</span>
		<span class="glyphicon glyphicon-info-sign" *ngIf="info && info.length > 0" [tooltip]="info"></span>
		<select autocomplete="on" [(ngModel)]="internalObject.id" class="form-control" id="{{randomId}}"[ngClass]="getClass() + ' ' + getHighlight()" (change)="onChange()"
			[disabled]="submitPending" [attr.aria-required]="mandatory">
			<option [value]="-1">{{labelNoSelection}}</option>
			<option
				*ngFor="let option of optionsCombo | removeFilter : viewRimossi:valueRimosso:valueOption:internalObject.id"
				[value]="option?option[valueOption]:null" [disabled]="disabledCheck && option[disabledCheckProperty]">
				<ng-template [ngIf]="!isImporto">
					<ng-container *ngFor="let labelOpt of [(getLabelOption( option, (labelOption ? labelOption : 'label')))]">
						{{labelOpt}}
					</ng-container>
				</ng-template>
			</option>
		</select>
	</p>
</ng-template>
